export const BUNDLE_STATES = {
  PROCESSING: 'P',
  SIGNED: 'S',
  UPLOADED: 'U',
  DONE: 'D',
  ERROR: 'E',
};

export const APP_STATES = {
  NEW: 'U',
  PENDING: 'N',
  REJECTED: 'J',
  READY_TO_PUBLISH: 'A',
  PUBLISHED: 'P',
  REMOVED: 'R',
  NEED_TO_CHANGE: 'C',
  SUSPENDED: 'S',
};
